
// ######====== IMPORTS GENERAL
// basic imports
import React from "react";

// routes imports
import routes_web from "../../connections/routes_web"; 

// ######====== VIEW COMPONENT
const NotFound = () => {
  const handleHome = async () => {
    window.location.href = routes_web.home;
  };

  return (
    <div className="w-full h-screen bg-gray-900 text-white">
      <div className="container mx-auto h-full flex items-center justify-center relative px-4">
        {/* Content Wrapper */}
        <div className="relative z-10 bg-gray-800 bg-opacity-90 rounded-2xl shadow-lg w-full max-w-4xl flex overflow-hidden h-[70vh]">
          
          {/* Image Section */}
          <div
            className="w-1/2 h-full bg-cover bg-center"
            style={{ backgroundImage: `url(${routes_web.img_error_bg})` }}
          ></div>

          {/* Text Section */}
          <div className="w-1/2 p-10 flex flex-col justify-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 text-gray-100">
              404 NOT FOUND
            </h1>

            {/* Home Button */}
            <div className="bottom-4 center-4 z-20">
              <button
                onClick={handleHome}
                className="px-4 py-2 border border-gray-400 text-gray-200 rounded hover:bg-gray-700"
              >
                Home
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
